import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import endpoints from '../../define/endpoints';

const Avatar = ({ size, profileImage, firstName, lastName, className }) => {
  const addClasses = className ? className : '';
  const [imageSource, setImageSource] = useState(null);
  const fallback =
    'https://freedome.it/wp-content/themes/app-theme/assets/o/images/default-user-icon.jpg';
  const initials = firstName && lastName ? `${firstName[0]}${lastName[0]}` : '';

  useEffect(() => {
    if (profileImage) {
      setImageSource(
        profileImage.startsWith('https://') || profileImage.startsWith('blob')
          ? profileImage
          : `${endpoints.bucket}${profileImage}`
      );
    } else {
      setImageSource(null);
    }
  }, [profileImage]);

  const handleImageError = () => {
    setImageSource(null);
  };

  return (
    <div className={`dynamic-avatar--${size} ${addClasses}`}>
      {imageSource && (
        <img
          src={imageSource}
          alt={firstName}
          loading="lazy"
          onError={handleImageError}
        />
      )}

      {firstName && !imageSource && initials && (
        <div className="placeholder">{initials}</div>
      )}

      {firstName && !imageSource && !initials && (
        <div className="placeholder">{firstName.slice(0, 2).toUpperCase()}</div>
      )}

      {!firstName && !imageSource && (
        <img
          src={fallback}
          alt={firstName}
          loading="lazy"
          onError={(e) => {
            e.target.src = fallback;
          }}
        />
      )}
    </div>
  );
};

Avatar.propTypes = {
  size: PropTypes.string,
  profileImage: PropTypes.string,
  firstName: PropTypes.string,
};

export const AvatarSizes = {
  xxs: 'xxs',
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl',
  xxl: 'xxl',
};

export default Avatar;
